import { render, staticRenderFns } from "./NegociacaoAlterarRespostaDadosBasicos.vue?vue&type=template&id=248d2aa5&"
import script from "./NegociacaoAlterarRespostaDadosBasicos.vue?vue&type=script&lang=js&"
export * from "./NegociacaoAlterarRespostaDadosBasicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VIcon,VRow,VSubheader})
